import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import {
  Input,
  Checkbox,
  Spin,
  Button,
  Badge,
  Popover,
  Divider,
} from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { settaskBoardDetails } from 'store/actions';
import { settaskstatuscount } from 'store/actions';
import { setFilteredrequestBody } from 'store/actions';
import { setadminboardetails } from 'store/actions';
import { setBoardfilterapplied } from 'store/actions';
 
const FILTER_OPTIONS = ['Parent', 'Sprint', 'Assignee', 'Labels', 'Status', 'TaskType'];
 
const getLabel = (item, filterType) => {
  switch (filterType) {
    case 'Sprint':
      return item.sprint_name;
    case 'Assignee':
      return item.username;
    case 'Labels':
      return item.label_name;
    case 'Status':
      return item.status_name;
    case 'Parent':
      return item.epic_name;
    case 'TaskType':
      return item.issue_type;
    default:
      return item.name || item.label || item.title || item.status;
  }
};
 
const FilterDropdownPanel = ({status, getTaskBoards, selectedfilterAssignee, onAssigneeChange, onClearAll}) => {
  const [tas, set] = useState({});
  //  const [taskStatusCount, setTaskStatusCount] = useState({});
  const [visible, setVisible] = useState(false);
  const [activeFilter, setActiveFilter] = useState('Sprint');
  const [submenuData, setSubmenuData] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const projectId = useParams();
  const dispatch = useDispatch();
   const roleId = Number(Cookies.get('task-role-id'));
  
 
  const fetchSubmenu = async (filterType) => {
    if (submenuData[filterType]) return;
    setLoading(true);
    const id = Number(projectId?.id);
 
    try {
      let response;
 
      switch (filterType) {
        case 'Sprint':
          response = await httpInjectorService.boardFilterSprints(id);
          if (
            response?.status === 'success' &&
            Array.isArray(response.data?.active_sprints)
          ) {
            setSubmenuData((prev) => ({
              ...prev,
              [filterType]: response.data.active_sprints.map((sprint) => ({
                id: sprint.sprint_id,
                sprint_name: sprint.sprint_name,
                status: sprint.status,
              })),
            }));
          } else {
            toast.error('Failed to fetch active sprints');
            setSubmenuData((prev) => ({ ...prev, [filterType]: [] }));
          }
          return;
 
        case 'Assignee':
          response = await httpInjectorService.getProjectAssignedEmployeelist(id);
          if (response?.status === 'success') {
            setSubmenuData((prev) => ({
              ...prev,
              [filterType]: response.data.map((user) => ({
                id: user.user_id,
                username: user.username,
                email: user.email,
              })),
            }));
          }
          return;
 
        case 'Labels':
          response = await httpInjectorService.boardFilterLabels(id);
          break;
 
        case 'Status':
          response = await httpInjectorService.ListBoardStatus(id);
          break;
 
        case 'Parent':
          response = await httpInjectorService.boardFilterEpics(id);
          break;
        case 'TaskType':
          response =await httpInjectorService.getIssueTypes();
          break;
 
        default:
          response = { status: 'error', data: [] };
      }
 
      if (response?.status === 'success' && Array.isArray(response.data)) {
        setSubmenuData((prev) => ({
          ...prev,
          [filterType]: response.data.map((item) => ({
            ...item,
            id: item.id || item.label_id || item.status_id || item.epic_id || item.issue_type_id
          })),
        }));
      } else {
        toast.error(`Failed to fetch ${filterType}`);
        setSubmenuData((prev) => ({ ...prev, [filterType]: [] }));
      }
    } catch (err) {
      toast.error(`Error fetching ${filterType}`);
      setSubmenuData((prev) => ({ ...prev, [filterType]: [] }));
    } finally {
      setLoading(false);
    }
  };
 
  

 
// const applyFilter = async (data) => {
//   try {
//     const response = await httpInjectorService.filteringBoardPage(data);
 
//     if (
//       response.status === 'success' &&
//       Array.isArray(response.data?.epics)
//     ) {
//       toast.success(response.message, {
//         position: 'top-right',
//         autoClose: 3000,
//       });
 
//       const grouped = {};
 
//       // Initialize empty arrays for each status
//       status?.forEach((s) => {
//         grouped[s.status_name] = [];
//       });
 
//       // Flatten and group tasks from all epics
//       response.data.epics.forEach((epic) => {
//         if (Array.isArray(epic.tasks)) {
//           epic.tasks.forEach((task) => {
//             const simplifiedTask = {
//               id: task.task_id,
//               title: task.task_title,
//               assignee_id: task.assignee_id,
//               assignee_name: task.assignee_name,
//               project_id: task.project_id,
//               epic_key: task.epic_key,
//               epic_name: task.epic_name,
//               task_status: task.task_status,
//               task,
//             };
 
//             if (grouped[task.task_status]) {
//               grouped[task.task_status].push(simplifiedTask);
//             }
//           });
//         }
//       });
 
//       // Update state & redux
//       set(grouped);
//       dispatch(settaskBoardDetails(grouped));
//         response.data.epics.forEach((epic) => {
//   if (!Array.isArray(epic.tasks)) return;

//   epic.tasks.forEach((task) => {
//     console.log(task, 'taskfilter');

//     const statusKey = task.task_status?.toUpperCase();

//     const simplifiedTask = {
//       id: task.task_id,
//       title: task.task_title,
//       assignee_id: task.assignee_id,
//       assignee_name: task.assignee_name,
//       project_id: task.project_id,
//       epic_key: epic.epic_key,   
//       epic_name: epic.epic_name, // safer from epic
//       task_status:task.task_status,
//       task,
//     };

//     console.log(simplifiedTask, 'simplifiedTask');

//     if (grouped[task.task_status]) {
//       grouped[task.task_status].push(simplifiedTask);
//     }
//   });
// });
//       dispatch(setadminboardetails(grouped));
 
//       // Map status summary to an object like { "QA": 2, "TO DO": 1, ... }
//       if (Array.isArray(response.data.status_summary)) {
//         const statusCountObj = {};
//         response.data.status_summary.forEach((item) => {
//           statusCountObj[item.task_status] = item.status_count;
//         });
//         // setTaskStatusCount(statusCountObj);
//          dispatch(settaskstatuscount(statusCountObj))
//       }
//     } else {
//        toast.error(response.message, {
//          position: 'top-right',
//          autoClose: 3000,
//        });
//       // Handle empty results
//       dispatch(settaskBoardDetails({}));
//        await getTaskBoards()
//       set({});
//       dispatch(settaskstatuscount({}))
//     }
//   } catch (error) {
//     set({});
//   }
// };
 

// const applyFilter = async (data) => {
//   try {
//     const response = await httpInjectorService.filteringBoardPage(data);

//     if (
//       response.status === 'success' &&
//       Array.isArray(response.data?.epics)
//     ) {
//       toast.success(response.message, {
//         position: 'top-right',
//         autoClose: 3000,
//       });

   
//       const taskMap = {};
//       const groupedEpics = {};

//       response.data.epics.forEach((epic) => {
//         taskMap[epic.epic_id] = epic.tasks || [];
//       });

//       response.data.epics.forEach((epic) => {
//         groupedEpics[epic.epic_id] = {
//           epic_id: epic.epic_id,
//           epic_name: epic.epic_name,
//           epic_key: epic.epic_key,
//           description: epic.description,
//           start_date: epic.start_date,
//           due_date: epic.due_date,
//           epic_status: epic.epic_status,
//           labels_id: epic.labels_id,
//           epic_colour: epic.epic_colour,
//           task_status_count: epic.task_status_count,
//           tasks: taskMap[epic.epic_id] || [],
//         };
//       });

//       /* -----------------------------------
//          2️⃣ BUILD grouped (STATUS VIEW)
//       ----------------------------------- */
//       const grouped = {};

//       // Initialize statuses
//       status?.forEach((s) => {
//         grouped[s.status_name.toUpperCase()] = [];
//       });

//       response.data.epics.forEach((epic) => {
//         if (!Array.isArray(epic.tasks)) return;

//         epic.tasks.forEach((task) => {
//           const statusKey = task.task_status?.toUpperCase();
//           if (!grouped[statusKey]) return;

//           grouped[statusKey].push({
//             id: task.task_id,
//             title: task.task_title,
//             assignee_id: task.assignee_id,
//             assignee_name: task.assignee_name,
//             project_id: task.project_id,
//             epic_key: epic.epic_key,
//             epic_name: epic.epic_name,
//             task_status: statusKey,
//             task,
//           });
//         });
//       });

   
//       if (roleId === 1) {
       
//         dispatch(setadminboardetails(groupedEpics));
//       } else {
//         set(grouped);
//         dispatch(settaskBoardDetails(grouped));
//       }

//       /* -----------------------------------
//          4️⃣ STATUS SUMMARY
//       ----------------------------------- */
//       if (Array.isArray(response.data.status_summary)) {
//         const statusCountObj = {};
//         response.data.status_summary.forEach((item) => {
//           statusCountObj[item.task_status.toUpperCase()] =
//             item.status_count;
//         });
//         dispatch(settaskstatuscount(statusCountObj));
//       }
//     } else {
//       toast.error(response.message, {
//         position: 'top-right',
//         autoClose: 3000,
//       });

//       set({});
//       dispatch(settaskBoardDetails({}));
//       dispatch(settaskstatuscount({}));
//       await getTaskBoards();
//     }
//   } catch (error) {
//     set({});
//   }
// };

const applyFilter = async (data) => {
  try {
    const response =
      roleId === 1
        ? await httpInjectorService.adminBoardDetails(data)
        : await httpInjectorService.filteringBoardPage(data);

    const rawEpics =
      roleId === 1 ? response.data : response.data?.epics;

    const normalizedEpics = (rawEpics || []).map((epic) => ({
      ...epic,
      tasks: epic.tasks ?? epic.task ?? [],
    }));

    if (response.status === 'success' && Array.isArray(normalizedEpics)) {
    

      const taskMap = {};
      const groupedEpics = {};

      normalizedEpics.forEach((epic) => {
        taskMap[epic.epic_id] = epic.tasks;
      });

      normalizedEpics.forEach((epic) => {
        groupedEpics[epic.epic_id] = {
          epic_id: epic.epic_id,
          epic_name: epic.epic_name,
          epic_key: epic.epic_key,
          description: epic.description,
          start_date: epic.start_date,
          due_date: epic.due_date,
          epic_status: epic.epic_status,
          labels_id: epic.labels_id,
          epic_colour: epic.epic_colour,
          task_status_count: epic.task_status_count,
          tasks: epic.tasks,
        };
      });

      const grouped = {};
      status?.forEach((s) => {
        grouped[s.status_name.toUpperCase()] = [];
      });

      normalizedEpics.forEach((epic) => {
        epic.tasks.forEach((task) => {
          const statusKey = task.issue_status?.toUpperCase();
          if (!grouped[statusKey]) return;

          grouped[statusKey].push({
            id: task.issue_id,
            title: task.issue_title,
            assignee_id: task.assignee_id,
            assignee_name: task.assignee_name,
            project_id: task.project_id,
            epic_key: epic.epic_key,
            epic_name: epic.epic_name,
            task_status: statusKey,
            task,
          });
        });
      });

      if (roleId === 1) {
        dispatch(setadminboardetails(groupedEpics));
      } else {
        set(grouped);
        dispatch(settaskBoardDetails(grouped));
      }

      if (Array.isArray(response.data?.status_summary)) {
        const statusCountObj = {};
        response.data.status_summary.forEach((item) => {
          statusCountObj[item.task_status.toUpperCase()] =
            item.status_count;
        });
        dispatch(settaskstatuscount(statusCountObj));
      }
    }
  } catch (error) {
    set({});
  }
};



  useEffect(() => {
    if (visible) fetchSubmenu(activeFilter);
  }, [activeFilter, visible]);
 
//  const handleCheckboxChange = (filterType, item, checked) => {
//     const prevSet = checkedItems[filterType] || new Set();
//     const updatedSet = new Set(prevSet);

//     const identifier =
//       item.id ?? item.label_id ?? item.status_id ?? item.epic_id;

//     const itemKey = identifier + '-' + getLabel(item, filterType); // unique key

//     const itemObj = {
//       id: identifier,
//       label: getLabel(item, filterType),
//       raw: item,
//     };

//     if (checked) {
//       updatedSet.add(itemObj);
//     } else {
//       [...updatedSet].forEach((i) => {
//         if (i.id === itemObj.id && i.label === itemObj.label) {
//           updatedSet.delete(i);
//         }
//       });
//     }

//     setCheckedItems((prev) => ({ ...prev, [filterType]: updatedSet }));
//   };

const handleCheckboxChange = (filterType, item, checked) => {
  const prevSet = checkedItems[filterType] || new Set();
  const updatedSet = new Set(prevSet);

  const identifier =
    item.id ?? item.label_id ?? item.status_id ?? item.epic_id;

  const itemObj = {
    id: identifier,
    label: getLabel(item, filterType),
    raw: item,
  };

  if (checked) {
    updatedSet.add(itemObj);
  } else {
    for (const i of updatedSet) {
      if (i.id === itemObj.id && i.label === itemObj.label) {
        updatedSet.delete(i);
        break;
      }
    }
  }

  
  setCheckedItems((prev) => ({ ...prev, [filterType]: updatedSet }));

  // If filter is Assignee — immediately inform parent
  if (filterType === 'Assignee' && typeof onAssigneeChange === 'function') {
    const assigneeIds = Array.from(updatedSet).map((i) => i.id);
    onAssigneeChange(assigneeIds);
  }
};

  useEffect(() => {
    // Check if no filters are selected
    const noFiltersSelected = Object.values(checkedItems).every(
      (set) => !set || set.size === 0,
    );

    if (noFiltersSelected) {
      // Call getTaskBoards when there are no filters
      dispatch(setBoardfilterapplied(false))
       dispatch(setFilteredrequestBody({}));

      // getTaskBoards();
    } else {
      // Otherwise apply filters
      const requestBody = buildRequestBody();
     
      dispatch(setFilteredrequestBody(requestBody));
      dispatch(setBoardfilterapplied(true))
      // applyFilter(requestBody);
    }
  }, [checkedItems]);

  
 
const buildRequestBody = () => {
  const id = Number(projectId?.id);
  const extractIds = (filterType) =>
  Array.from(checkedItems[filterType] || []).map((item) => item.id);
  const extractStatusNames = () =>
  Array.from(checkedItems['Status'] || []).map((item) => item.label);
  return {
    project_id: id,
    sprint_id: extractIds('Sprint'),
    epic_id: extractIds('Parent'),
    assignee_id: extractIds('Assignee'),
    issue_status: extractStatusNames(),
    labels_id: extractIds('Labels'),
    issue_type_id:extractIds('TaskType')
  };
};

// useEffect(() => {
//   if (!submenuData['Assignee']) {
//     fetchSubmenu('Assignee');
//     return; 
//   }

//   if (selectedfilterAssignee && selectedfilterAssignee.length > 0) {
   
//     const matchedAssignees = submenuData['Assignee'].filter((user) =>
//       selectedfilterAssignee.includes(user.id)
//     );

//     const updatedSet = new Set(
//       matchedAssignees.map((user) => ({
//         id: user.id,
//         label: getLabel(user, 'Assignee'),
//         raw: user,
//       }))
//     );

//     setCheckedItems((prev) => ({ ...prev, Assignee: updatedSet }));

   
//     const requestBody = {
//       project_id: Number(projectId?.id),
//       sprint_id: Array.from(checkedItems['Sprint'] || []).map((i) => i.id),
//       epic_id: Array.from(checkedItems['Parent'] || []).map((i) => i.id),
//       assignee_id: Array.from(updatedSet).map((i) => i.id),
//       task_status: Array.from(checkedItems['Status'] || []).map((i) => i.label),
//       labels_id: Array.from(checkedItems['Labels'] || []).map((i) => i.id),
//     };

//     applyFilter(requestBody);
//   } else {
   
//     setCheckedItems((prev) => ({ ...prev, Assignee: new Set() }));

  
//     getTaskBoards();

   
//   }
// }, [selectedfilterAssignee, submenuData['Assignee']]);

 
useEffect(() => {
  if (!submenuData['Assignee']) {
    fetchSubmenu('Assignee');
    return;
  }

  let updatedSet = new Set(); // default empty

  if (selectedfilterAssignee && selectedfilterAssignee.length > 0) {
    const matchedAssignees = submenuData['Assignee'].filter((user) =>
      selectedfilterAssignee.includes(user.id)
    );

    updatedSet = new Set(
      matchedAssignees.map((user) => ({
        id: user.id,
        label: getLabel(user, 'Assignee'),
        raw: user,
      }))
    );
  }

  // 🔥 THIS LINE FIXES EVERYTHING
  setCheckedItems((prev) => ({ ...prev, Assignee: updatedSet }));

}, [selectedfilterAssignee, submenuData['Assignee']]);


  const clearFilter = (filterType) => {
    setCheckedItems((prev) => ({ ...prev, [filterType]: new Set() }));
    //  onClearAll();
     if (filterType === 'Assignee' && typeof onAssigneeChange === 'function') {
    onAssigneeChange([]); // clear parent selected assignees
  }
  };
 
  const clearAll = () => {
    setCheckedItems({});
    // onClearAll();
     if (typeof onAssigneeChange === 'function') onAssigneeChange([]); // clear parent too
  if (typeof onClearAll === 'function') onClearAll();
   
  };

  
 
 
  const filteredItems = Array.isArray(submenuData[activeFilter])
    ? submenuData[activeFilter].filter((item) => {
        const label = getLabel(item, activeFilter);
        return label?.toLowerCase()?.includes(searchTerm.toLowerCase());
      })
    : [];
 
  const totalSelected = Object.values(checkedItems).reduce(
    (sum, set) => sum + set.size,
    0
  );

  
 
 const content = (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      width: '90vw',
      maxWidth: 700,
      height: '50vh',
      // Height: '40vh',
      border: '1px solid #eee',
      borderRadius: 6,
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      background: '#fff',
      overflow: 'hidden',
    }}
    data-tour="board-filter"
  >
    {/* Sidebar (left) */}
    <div
      style={{
        width: '30%',
        minWidth: 150,
        maxWidth: 200,
        borderRight: '1px solid #eee',
        padding: 12,
        background: '#fafafa',
        overflowY: 'auto',
      }}
    >
      <div style={{ marginBottom: 12 }}>
        <Button type="link" onClick={clearAll} style={{ color: '#884B9E' }}>
          Clear all
        </Button>
      </div>

      {FILTER_OPTIONS.map((filter) => {
        const count = checkedItems[filter]?.size || 0;
        return (
          <div
            key={filter}
            onClick={() => setActiveFilter(filter)}
            style={{
              padding: '6px 12px',
              cursor: 'pointer',
              background: activeFilter === filter ? '#e6f7ff' : 'transparent',
              borderRadius: 4,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 4,
              fontWeight: activeFilter === filter ? 'bold' : 'normal',
              wordWrap: 'break-word',
            }}
          >
            <span>{filter}</span>
            {count > 0 && (
              <Badge count={count} style={{ backgroundColor: '#722ED1' }} />
            )}
          </div>
        );
      })}
    </div>

    {/* Right panel: search + ONE scrollable container that includes list + footer */}
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 16,
        height: '100%',
      }}
    >
      {/* Search (fixed at top of right panel) */}
      <Input
        placeholder={`Search ${activeFilter.toLowerCase()}`}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 12 }}
        allowClear
      />

      {/* THIS container scrolls: contains list AND footer (so footer scrolls into view) */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          paddingRight: 4,
          // optional: leave space at bottom so final items not hidden behind popover edge
          paddingBottom: 12,
        }}
      >
        <Spin spinning={loading}>
          {filteredItems.map((item) => {
            const itemId = item.id?.toString();
            const isChecked = Array.from(checkedItems[activeFilter] || []).some(
              (i) => i.id === item.id && i.label === getLabel(item, activeFilter)
            );
            const label = getLabel(item, activeFilter);

            return (
              <div
                key={itemId}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '6px 0',
                  borderBottom: '1px solid #eee',
                }}
              >
                <Checkbox
                  className="inline-purple-checkbox"
                  checked={isChecked}
                  onChange={(e) =>
                    handleCheckboxChange(activeFilter, item, e.target.checked)
                  }
                >
                  <strong style={{ fontWeight: isChecked ? 'bold' : 'normal' }}>
                    {label}
                  </strong>
                </Checkbox>
              </div>
            );
          })}

          {/* Footer inside the scrollable area so it scrolls with the list */}
          <div style={{ marginTop: 12 }}>
            <Divider style={{ margin: '8px 0' }} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
              }}
            >
              <Button
                type="link"
                onClick={() => clearFilter(activeFilter)}
                style={{ color: '#722ED1' }}
              >
                Clear
              </Button>

              <span style={{ fontSize: 12, color: '#555' }}>
                {filteredItems.length} of {submenuData[activeFilter]?.length || 0}
              </span>
            </div>

            
          </div>
        </Spin>
      </div>
    </div>
  </div>
);



 
  return (
    <Popover
      content={content}
      trigger="click"
      placement="bottomLeft"
      open={visible}
      onOpenChange={(open) => setVisible(open)}
    >
      <Badge count={totalSelected} offset={[6, 0]} color="#722ED1">
        <Button
          icon={<FilterOutlined />}
          style={{
            backgroundColor: '#722ED1',
            color: 'white',
            borderRadius: 10,
            padding: '0 16px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          Filter
        </Button>
      </Badge>
    </Popover>
  );
};
 
export default FilterDropdownPanel;